module.exports = __webpack_public_path__ + "img/bookmark_off.67ed50a3.svg";